import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConnectDialog, ConnectDialogType} from "./connect-dialog";


@Component({
    selector: 'connect-confirm-dialog',
    templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements OnInit {
    title: string;
    message: string;
    showInputText: boolean;
    showTextArea: boolean;
    notes : string;
    inputText: string;
    inputLabel: string;
    textAreaText: string;
    textAreaLabel: string;
    showCancelBtn : boolean = true;
    okBtnText : string ;
    cancelBtnText : string;
    dialogType : ConnectDialogType = 'INFORMATION';
    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public connectDialog: ConnectDialog) {
        // Update view with given values
        this.title = connectDialog.title;
        this.message = connectDialog.message;
        this.showCancelBtn = connectDialog.showCancelBtn;
        this.showInputText = connectDialog.showInputText;
        this.inputLabel = connectDialog.inputLabel;
        this.notes = connectDialog.notes;
        this.dialogType = connectDialog.dialogType;
        this.okBtnText = connectDialog.okBtnText;
        this.cancelBtnText = connectDialog.cancelBtnText;
        this.showTextArea = connectDialog.showTextArea;
        this.textAreaLabel = connectDialog.textAreaLabel;
        this.textAreaText = connectDialog.textAreaText;
    }

    ngOnInit() {
    }

    onConfirm(): void {
        if(this.showInputText){
            // Close the dialog, return true and the value of the input text
            this.dialogRef.close({isOkClicked: true, inputText: this.inputText, textAreaText: this.textAreaText});
        } else {
            // Close the dialog, return true
            this.dialogRef.close(true);
        }

    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }

    get dialogTitle() : string {
        if(!!this.title){
            return this.camalize(this.title);
        }
        else if(!!this.dialogType){
            return this.camalize(this.dialogType);
        }
        else{
            return 'Information';
        }
    }

    camalize(str) : string {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ?  word.toUpperCase() : word.toLowerCase();
        }).replace(/\s+/g, '');
    }

    get dialogIcon() : string {
        if(this.dialogType == 'INFORMATION'){
            return 'fa fa-info-circle';
        }
        else if(this.dialogType == 'ERROR'){
            return 'fa  fa-times-circle';
        }
        else if(this.dialogType == 'WARNING'){
            return 'fa fa-exclamation-triangle';
        }
        else if(this.dialogType == 'SUCCESS'){
            return 'fa fa-check-circle';
        }
        else{
            return 'fa fa-info-circle';
        }
    }

    get dialogClass() : string {
        if(this.dialogType == 'INFORMATION'){
            return 'info';
        }
        else if(this.dialogType == 'ERROR'){
            return 'danger';
        }
        else if(this.dialogType == 'WARNING'){
            return 'warning';
        }
        else if(this.dialogType == 'SUCCESS'){
            return 'success';
        }
        else{
            return 'info';
        }
    }
}

